import moment from 'moment';

import { appEventTypes } from 'events/app';
import { uiEventTypes } from 'events/ui';
import { configurationEventTypes } from 'events/configuration';
import uiSelectors from 'selectors/ui';
import uiEnums from 'enums/ui';
import initialState from 'reducers/initialStates/ui';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case uiEventTypes.UPDATE_UNREAD_MESSAGE_COUNT:
      return handleUpdatedUnreadMessageCount(state, action);

    case uiEventTypes.WIDGET_AUTO_SHOW:
      return handleWidgetAutoShow(state);

    case uiEventTypes.WIDGET_HIDE:
      return handleWidgetHide(state);

    case uiEventTypes.WIDGET_MINIMIZE:
      return handleWidgetMinimize(state);

    case uiEventTypes.WIDGET_UNMINIMIZE:
      return handleWidgetUnminimize(state);

    case appEventTypes.AUTHENTICATION_ERROR:
      return handleAuthenticationError(state);

    case appEventTypes.AUTHENTICATION_SUCCESS:
      return handleAuthenticationSuccess(state);

    case configurationEventTypes.CONFIG_OFFICE_CLOSED:
      return handleOfficeClosed(state);

    case configurationEventTypes.CONFIG_CHAT_THROTTLED:
      return handleChatThrottled(state);

    case uiEventTypes.WIDGET_UPDATE_ATTACHMENT_ERROR:
      return handleWidgetUpdateAttachmentError(state, action);

    case uiEventTypes.WIDGET_UPDATE_COMPOSITION_DRAFT:
      return handleWidgetUpdateCompositionDraft(state, action);

    case uiEventTypes.WIDGET_UPDATE_COMPOSITION_STAGE:
      return handleWidgetUpdateCompositionStage(state, action);

    case uiEventTypes.WIDGET_SUPPRESS:
      return handleWidgetSuppress(state);

    case uiEventTypes.WIDGET_UPDATE_USER_COMPOSITION:
      return handleWidgetUpdateUserComposition(state, action);

    case uiEventTypes.WIDGET_UNSUPPRESS:
      return handleWidgetUnsuppress(state);

    case uiEventTypes.WIDGET_UPDATE_STAGE:
      return handleWidgetUpdateStage(state, action);

    case uiEventTypes.WIDGET_UPDATE_VISIBILITY:
      return handleWidgetUpdateVisibility(state, action);

    case uiEventTypes.WIDGET_NAVIGATE_REPLACE:
      return handleWidgetNavigateReplace(state, action);

    case uiEventTypes.WIDGET_NAVIGATE_FORWARD:
      return handleWidgetNavigateForward(state, action);

    case uiEventTypes.WIDGET_NAVIGATE_BACK:
      return handleWidgetNavigateBack(state, action);

    default:
      return state;
  }
}

function handleUpdatedUnreadMessageCount(state, action) {
  return {
    ...state,
    unreadMessageCount: action.payload.unreadMessageCount,
  };
}

function handleWidgetAutoShow(state) {
  return {
    ...state,
    autoShowWidget: true,
  };
}

function handleWidgetHide(state) {
  return {
    ...state,
    isVisible: false,
  };
}

function handleWidgetMinimize(state) {
  const now = moment()
    .utc()
    .format();
  const currentLocation = uiSelectors.getCurrentLocation(state);
  const chatLastViewedAt = currentLocation === uiEnums.LOCATIONS.CHAT ? now : state.chatLastViewedAt;

  return {
    ...state,
    chatLastViewedAt,
    minimizedAt: now,
    isMinimized: true,
  };
}

function handleWidgetUnminimize(state) {
  const currentLocation = uiSelectors.getCurrentLocation(state);
  const chatLastViewedAt = currentLocation === uiEnums.LOCATIONS.CHAT ? null : state.chatLastViewedAt;

  return {
    ...state,
    chatLastViewedAt,
    minimizedAt: null,
    isMinimized: false,
  };
}

function handleAuthenticationError(state) {
  return {
    ...state,
    stage: uiEnums.STAGES.ONBOARDING,
  };
}

function handleAuthenticationSuccess(state) {
  // a temporary fix for not updating the stage to CHAT in the self service widget
  const currentLocation = uiSelectors.getCurrentLocation(state);
  const stage = currentLocation === uiEnums.LOCATIONS.CHAT ? uiEnums.STAGES.SELF_SERVICE : uiEnums.STAGES.CHAT;

  return {
    ...state,
    stage,
  };
}

function handleOfficeClosed(state) {
  return {
    ...state,
    stage: uiEnums.STAGES.CHAT_CLOSED,
  };
}

function handleChatThrottled(state) {
  return {
    ...state,
    stage: uiEnums.STAGES.CHAT_THROTTLED,
  };
}

function handleWidgetUpdateAttachmentError(state, action) {
  return {
    ...state,
    attachmentError: action.payload,
  };
}

function handleWidgetUpdateCompositionDraft(state, action) {
  return {
    ...state,
    compositionDraft: action.payload.text,
  };
}

function handleWidgetUpdateCompositionStage(state, action) {
  return {
    ...state,
    compositionStage: action.payload,
  };
}

function handleWidgetSuppress(state) {
  return {
    ...state,
    suppressedByRules: true,
  };
}

function handleWidgetUpdateUserComposition(state, action) {
  return {
    ...state,
    userComposition: {
      attachments: action.payload.attachments,
      text: action.payload.text,
    },
  };
}

function handleWidgetUnsuppress(state) {
  return {
    ...state,
    suppressedByRules: false,
  };
}

function handleWidgetUpdateStage(state, action) {
  return {
    ...state,
    stage: action.payload.stage,
  };
}

function handleWidgetUpdateVisibility(state, action) {
  return {
    ...state,
    isVisible: action.payload.isVisible,
  };
}

function handleWidgetNavigateReplace(state, action) {
  let locationHistory = state.locationHistory;
  locationHistory.pop();
  return {
    ...state,
    locationHistory: [...locationHistory, action.payload.location],
    chatLastViewedAt: action.payload.location === uiEnums.LOCATIONS.CHAT ? null : state.chatLastViewedAt,
  };
}

function handleWidgetNavigateForward(state, action) {
  return {
    ...state,
    locationHistory: [...state.locationHistory, action.payload.location],
    chatLastViewedAt: action.payload.location === uiEnums.LOCATIONS.CHAT ? null : state.chatLastViewedAt,
  };
}

function handleWidgetNavigateBack(state) {
  const now = moment()
    .utc()
    .format();
  const newState = Object.assign({}, state);
  const lastLocation = newState.locationHistory.pop();
  const chatLastViewedAt = lastLocation === uiEnums.LOCATIONS.CHAT ? now : state.chatLastViewedAt;

  return {
    ...state,
    locationHistory: newState.locationHistory,
    chatLastViewedAt,
  };
}
